import ReCAPTCHA, { type ReCAPTCHAProps } from 'react-google-recaptcha';
import cn from 'classnames';
import { useCallback } from 'react';
import { useField, useFormikContext } from 'formik';
import type { FieldConfig } from '@kolking/react-ui';

import styles from './styles/recaptcha.module.scss';

export interface FormReCAPTCHAProps extends FieldConfig, ReCAPTCHAProps {
  name: string;
}

export const FormReCAPTCHA = ({
  id,
  name,
  label,
  help,
  className,
  required,
  children,
  ...props
}: FormReCAPTCHAProps) => {
  const { submitCount } = useFormikContext();
  const [, meta, { setValue }] = useField<unknown>(name);
  const error = meta.touched || submitCount ? meta.error : undefined;
  const handleChange = useCallback((token: string | null) => void setValue(token), [setValue]);
  const handleError = useCallback(() => void setValue(undefined), [setValue]);

  return (
    <section className={cn(styles.recaptcha, className)}>
      <ReCAPTCHA
        {...props}
        id={id ?? name}
        onChange={handleChange}
        onExpired={handleError}
        onErrored={handleError}
      />
      <aside>
        {error && <div className={styles.error}>{error}</div>}
        {help && <div className={styles.help}>{help}</div>}
      </aside>
    </section>
  );
};
